import { render } from "./bread_crumbs.html?vue&type=template&id=2cc2cfc4&external"
import script from "./bread_crumbs.js?vue&type=script&lang=js&external"
export * from "./bread_crumbs.js?vue&type=script&lang=js&external"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=2cc2cfc4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__